import { ENV } from '@/infrastructure/env-config';
import { Platform } from '@/infrastructure/utils/app';

/**
 * 产品相关
 */
export default {
  demoProduct: ENV.isProd ? [
    { productId: 'a278f01047', platformId: Platform.Android },
    { productId: 'a2031e998b', platformId: Platform.IOS },
  ] : [
    { productId: '129a7bcc6e', platformId: Platform.Android }, // 测试环境
  ],
};
